import { z } from 'zod';

export const LoginDtoSchema = z.object({
    sid: z.string(),
    hasParametersPageAccess: z.boolean(),
});

export type LoginDto = z.infer<typeof LoginDtoSchema>;
